module.exports = __webpack_public_path__ + "img/calendar.68b5108d.svg";